import { gsap } from "@gsap";

const DRAG_THRESHOLD = 50;

function initSlider(slider) {
	const cards = [...slider.querySelectorAll(".industry-card")];
	if (cards.length < 2) return;

	let index = cards.findIndex((card) => card.classList.contains("is-active"));
	let startX = null;
	let dragged = false;

	const goTo = (next) => {
		index = Math.max(0, Math.min(cards.length - 1, next));
		slider.style.setProperty("--i", index);
		cards.forEach((card, i) => card.classList.toggle("is-active", i === index));
	};

	cards.forEach((card, i) => {
		const inner = card.querySelector(".industry-card-inner");

		inner.addEventListener("click", (event) => {
			if (dragged || i !== index) {
				event.preventDefault();
				if (!dragged) goTo(i);
			}
		});

		inner.addEventListener("focus", () => goTo(i));
	});

	slider.addEventListener("keydown", (event) => {
		if (event.key === "ArrowRight") goTo(index + 1);
		if (event.key === "ArrowLeft") goTo(index - 1);
	});

	let startY = 0;
	let lastX = 0;

	const reset = () => {
		startX = null;
		slider.classList.remove("is-dragging");
		slider.style.setProperty("--drag", "0px");
	};

	slider.addEventListener("pointerdown", (event) => {
		if (event.button !== 0) return;
		startX = lastX = event.clientX;
		startY = event.clientY;
		dragged = false;
	});

	window.addEventListener("pointermove", (event) => {
		if (startX === null) return;
		const deltaX = event.clientX - startX;
		const deltaY = event.clientY - startY;
		lastX = event.clientX;

		if (!dragged && Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 8) {
			reset();
			return;
		}

		if (Math.abs(deltaX) > 5) {
			dragged = true;
			slider.classList.add("is-dragging");
			slider.style.setProperty("--drag", `${deltaX}px`);
		}
	});

	window.addEventListener("pointerup", () => {
		if (startX === null) return;
		const delta = lastX - startX;
		reset();
		if (dragged && delta < -DRAG_THRESHOLD) goTo(index + 1);
		if (dragged && delta > DRAG_THRESHOLD) goTo(index - 1);
		setTimeout(() => (dragged = false), 0);
	});

	window.addEventListener("pointercancel", () => {
		reset();
		dragged = false;
	});

	const cursor = slider.querySelector(".industry-slider-cursor");
	if (!cursor) return;

	gsap.matchMedia().add("(hover: hover) and (pointer: fine)", () => {
		const moveX = gsap.quickTo(cursor, "x", { duration: 0.35, ease: "power3.out" });
		const moveY = gsap.quickTo(cursor, "y", { duration: 0.35, ease: "power3.out" });

		const onMove = (event) => {
			const rect = slider.getBoundingClientRect();
			moveX(event.clientX - rect.left);
			moveY(event.clientY - rect.top);
		};

		const onEnter = (event) => {
			const rect = slider.getBoundingClientRect();
			gsap.set(cursor, { x: event.clientX - rect.left, y: event.clientY - rect.top });
			slider.classList.add("has-cursor");
		};

		const onLeave = () => slider.classList.remove("has-cursor");

		slider.addEventListener("pointermove", onMove);
		slider.addEventListener("pointerenter", onEnter);
		slider.addEventListener("pointerleave", onLeave);

		return () => {
			slider.removeEventListener("pointermove", onMove);
			slider.removeEventListener("pointerenter", onEnter);
			slider.removeEventListener("pointerleave", onLeave);
			slider.classList.remove("has-cursor");
		};
	});
}

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".industry_slider-layout .industry-slider").forEach(initSlider);
});
